import { useCallback } from 'react';
import { ApiError } from '../ApiError';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

interface ApiOptions extends RequestInit {}

export const useApi = () => {
  const request = useCallback(async <T = any>(
    endpoint: string,
    options: ApiOptions = {}
  ): Promise<T> => {
    const token = localStorage.getItem("accessToken");

    const res = await fetch(`${API_BASE_URL}/${endpoint}`, {
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...(options.headers || {}),
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    });

    if (!res.ok) {
      const contentType = res.headers.get("content-type");
      let errorMessage = `Erro na requisição: ${res.status}`;

      if (contentType?.includes("application/json")) {
        const errorData = await res.json();
        errorMessage =
          errorData?.errors?.[0]?.message ||
          errorData?.message ||
          errorMessage;
      } else {
        const text = await res.text();
        if (text) errorMessage = `${errorMessage} - ${text}`;
      }

      throw new ApiError(errorMessage, res.status);
    }

    if (res.status === 204 || res.headers.get("content-length") === "0") {
      return null as T;
    }

    const contentType = res.headers.get("content-type");
    if (contentType?.includes("application/json")) {
      return res.json();
    }

    const text = await res.text();
    return (text || null) as T;
  }, []);

  return { request };
};
